import React, { useState } from "react";
import { User, Calendar, Building2 } from "lucide-react";

const sizeClasses = {
  xs: "w-8 h-8",
  sm: "w-10 h-10",
  md: "w-12 h-12",
  lg: "w-16 h-16",
  xl: "w-20 h-20",
  "2xl": "w-24 h-24",
  "3xl": "w-32 h-32",
};

const ThumbnailImage = ({
  src,
  alt = "Image",
  size = "md",
  variant = "logo",
  className = "",
  rounded = "lg",
  showBorder = true,
}) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getPlaceholderIcon = () => {
    const iconSize = size === "xs" || size === "sm" ? "w-4 h-4" : size === "md" ? "w-5 h-5" : "w-6 h-6";
    
    switch (variant) {
      case "logo":
        return <Building2 className={`${iconSize} text-grey-400`} />;
      case "event":
        return <Calendar className={`${iconSize} text-grey-400`} />;
      case "user":
        return <User className={`${iconSize} text-grey-400`} />;
      default:
        return <Building2 className={`${iconSize} text-grey-400`} />;
    }
  };

  const roundedClass = rounded === "full" ? "rounded-full" : `rounded-${rounded}`;
  const borderClass = showBorder ? "ring-1 ring-grey-200" : "";

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setHasError(true);
    setIsLoading(false);
  };

  const showPlaceholder = !src || hasError;

  return (
    <div
      className={`
        ${sizeClasses[size] || sizeClasses.md}
        ${roundedClass}
        ${borderClass}
        overflow-hidden
        flex-shrink-0
        bg-grey-50
        flex items-center justify-center
        ${className}
      `}
    >
      {showPlaceholder ? (
        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-grey-100 to-grey-50">
          {getPlaceholderIcon()}
        </div>
      ) : (
        <>
          {isLoading && (
            <div className="absolute inset-0 bg-grey-100 animate-pulse" />
          )}
          <img
            src={src}
            alt={alt}
            onLoad={handleLoad}
            onError={handleError}
            className={`
              w-full h-full object-cover
              transition-opacity duration-200
              ${isLoading ? "opacity-0" : "opacity-100"}
            `}
          />
        </>
      )}
    </div>
  );
};

export default ThumbnailImage;
